import { render, staticRenderFns } from "./BackgroundSearchBar.vue?vue&type=template&id=5a128151&scoped=true&"
import script from "./BackgroundSearchBar.vue?vue&type=script&lang=js&"
export * from "./BackgroundSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSearchBar.vue?vue&type=style&index=0&id=5a128151&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a128151",
  null
  
)

export default component.exports